module.exports = "/packs/1-34d7754326d9ade7bd1fb232aa481d91.svg";